// this is the view file for blinkup

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/blinkup.hbs';
import Radio from 'backbone.radio';
import Backbone from 'backbone';
	
    var globalCh = Radio.channel('global');

    var BlinkupView = Marionette.View.extend({
        template: Handlebars.compile(template),
        id: 'blinkup',
        tagName: 'div',
        className: 'standard-layout',
        ui: {
            start_blinkup: '.start-blinkup',
            ssid: '#ssid',
            password: '#password-wifi',
            reveal: '.reveal',
            my_dev_devices: '.my-dev-devices',
            account_selector: '#accountSelector',
        },
        events: {
            'submit form': 'onSubmit',
            'click @ui.reveal': 'show_hide_password',
            'click @ui.my_dev_devices': 'show_my_dev_devices_list',
        },
        templateContext: function() {
            var primary = globalCh.request('primary_account');
            var accounts = new Backbone.Collection();
            primary.proxies.each(function(a) {
                if ( a.permits(primary, 'allow_developer_enroll') ) accounts.add(a);
            });
            // add primary account always on top
            accounts.unshift(primary);

            return {accounts : accounts };
        },
        show_hide_password: function(e){
            e.preventDefault();
            if (this.ui.password.attr('type') === 'password') {
                this.ui.password.attr('type', 'text');
            } else {
                this.ui.password.attr('type', 'password');
            }
        },
        show_my_dev_devices_list: function(e) {
            e.preventDefault();
            globalCh.request('set_selection', {
                type: 'app',
                id: 'devices',
            });

            var primary = globalCh.request('primary_account');
            globalCh.request('show_my_development_devices', primary);
        },
        onSubmit: function(e) {
            e.preventDefault();
            var account_id = this.ui.account_selector.val();
            var ssid = this.ui.ssid.val();
            var password = this.ui.password.val();

            var login_info = {
                    ssid: ssid,
                    password: password
            };
            globalCh.request('show_blinkup_dialog', login_info, account_id);
                   
        },
    });
    export default BlinkupView;





